module.exports = __webpack_public_path__ + "static/6-91eadc635d920f79e9b623235b78a86c.jpg";